export var CallCenterAgentStatus;
(function (CallCenterAgentStatus) {
    CallCenterAgentStatus[CallCenterAgentStatus["ONLINE"] = 10] = "ONLINE";
    CallCenterAgentStatus[CallCenterAgentStatus["WRAPPING_UP"] = 20] = "WRAPPING_UP";
    CallCenterAgentStatus[CallCenterAgentStatus["RESERVED"] = 30] = "RESERVED";
    CallCenterAgentStatus[CallCenterAgentStatus["TALKING"] = 40] = "TALKING";
    CallCenterAgentStatus[CallCenterAgentStatus["LISTENING"] = 50] = "LISTENING";
    CallCenterAgentStatus[CallCenterAgentStatus["BUSY"] = 60] = "BUSY";
    CallCenterAgentStatus[CallCenterAgentStatus["OFFLINE"] = 100] = "OFFLINE";
})(CallCenterAgentStatus || (CallCenterAgentStatus = {}));
//# sourceMappingURL=callcenter-agent-status.enum.js.map